import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentEmployee, isAdmin } from '../../services/pinAuthService';

interface PINProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  redirectTo?: string;
}

export const PINProtectedRoute: React.FC<PINProtectedRouteProps> = ({
  children,
  requireAdmin = false,
  redirectTo = '/admin/login',
}) => {
  const employee = getCurrentEmployee();

  // Not logged in
  if (!employee) {
    return <Navigate to={redirectTo} replace />;
  }

  // Admin required but not admin
  if (requireAdmin && !employee.is_admin) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'VT323, monospace',
          fontSize: '1.5rem',
          color: '#ff0080',
          textAlign: 'center',
          padding: '20px',
        }}
      >
        <div>
          <div>ACCESS DENIED</div>
          <div style={{ fontSize: '1rem', marginTop: '20px', color: '#7b68ee' }}>
            Admin access required
          </div>
        </div>
      </div>
    );
  }

  // Authorized
  return <>{children}</>;
};

export default PINProtectedRoute;
